import rateLimit from 'axios-rate-limit';
import { endpoints } from '../../../config/connections';
import axios from "axios";

export const getAllUserData = async (userId) => {
    const getCDCPermissionURL = `${endpoints.apigee}/document-management/coreservice/user-management/v1/users/userId`;

    const https = rateLimit(
        axios.create({
            headers: {
                Accept: 'application/json',
                'Correlation-ID': `${sessionStorage.getItem('loggedUser')} ${sessionStorage.getItem('correlationId')}`,
                'Client-Application': 'CDC',
                'user-id': userId,
                'jwt': `${sessionStorage.getItem('tok')}`,
                Authorization: `Bearer ${sessionStorage.getItem('at')}`,
            },
        }),
        { maxRequests: 7, perMilliseconds: 1000, maxRPS: 7 }
    );

    return await https.get(getCDCPermissionURL);
}